import React, { useEffect, useState, useMemo } from 'react';
import {
  Box,
  Tabs,
  Tab,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Alert,
  Stack,
  Divider,
  TablePagination,
  InputAdornment,
  useMediaQuery,
  useTheme,
  Tooltip,
  FormControlLabel,
  Checkbox
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import {
  Add,
  Edit,
  Delete,
  Bed,
  LocalHospital,
  MonetizationOn,
  CheckCircle,
  Cancel,
  PersonAdd,
  People,
  PersonOutline,
  Hotel,
  Search,
  Close as CloseIcon
} from '@mui/icons-material';

import { addWardWithBeds, loadInsurancesddb,updateWarddb } from '../BaseURL';
import axios from 'axios';
import Swal from 'sweetalert2';
import { ErrorMessage, successMessage } from '../Message';
import { loadBedsdb, loadWardsdb, deleteWard ,deleteBed } from '../BaseURL';


export default function WardsBeds() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isDark = theme.palette.mode === 'dark';

  // Theme-aware surface tokens. The whole page reads from these so the
  // black theme and light theme both render coherently.
  const pageBg        = isDark ? '#000000' : '#F4F6FA';
  const surfaceBg     = isDark ? '#0E0E14' : '#FFFFFF';
  const surfaceBg2    = isDark ? '#14141C' : '#F8FAFC';
  const fieldBg       = isDark ? '#14141C' : '#FFFFFF';
  const borderSubtle  = isDark ? 'rgba(255,255,255,0.06)' : 'rgba(15,23,42,0.08)';
  const borderStrong  = isDark ? 'rgba(255,255,255,0.10)' : 'rgba(15,23,42,0.12)';
  const textPrimary   = isDark ? '#FFFFFF' : '#0F172A';
  const textMuted     = isDark ? 'rgba(255,255,255,0.6)' : 'rgba(15,23,42,0.6)';
  const cardShadow    = isDark
    ? '0 1px 2px rgba(0,0,0,0.4), 0 8px 24px rgba(0,0,0,0.35)'
    : '0 1px 2px rgba(15,23,42,0.04), 0 8px 24px rgba(15,23,42,0.06)';
  const rowHoverBg    = isDark ? 'rgba(255,255,255,0.03)' : 'rgba(15,23,42,0.03)';

  // Semantic accent colors used for stat tiles + count badges. The light
  // variants stay readable on both surfaces because we derive them from
  // alpha() instead of using Material's pastel 50/100 tones (which look
  // out of place against a black background).
  const accents = {
    primary: '#2563eb',   // blue
    success: '#10b981',   // emerald
    danger:  '#ef4444',   // red
    warning: '#f59e0b'    // amber
  };

  const [activeTab, setActiveTab] = useState(0);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogType, setDialogType] = useState('');
  const [editingItem, setEditingItem] = useState(null);

  const [applyAll, setApplyAll] = useState(false);
  const [globalDailyRate, setGlobalDailyRate] = useState("");
  const [globalDailyTariff, setGlobalDailyTariff] = useState("");

  // Search and Pagination States
  const [wardSearchQuery, setWardSearchQuery] = useState('');
  const [wardPage, setWardPage] = useState(0);
  const [wardRowsPerPage, setWardRowsPerPage] = useState(5);
  
  const [bedSearchQuery, setBedSearchQuery] = useState('');
  const [bedPage, setBedPage] = useState(0);
  const [bedRowsPerPage, setBedRowsPerPage] = useState(5);

 const [insurances, setInsurances] = useState([]);
 const [insuranceRates, setInsuranceRates] = useState([]);

  const [errors, setErrors] = useState({
    name: false,
    capacity: false,
    dailyRate: false
  });

  const [wards, setWards] = useState([]);
  const [beds, setBeds] = useState([]);


const loadInsurances = async () => {
  try {
    const res = await axios.get(loadInsurancesddb);

    if (res.data.success) {
      const insurancesList = res.data.insurances;
      setInsurances(insurancesList);

      // Initialize rates only if not editing
      if (!editingItem) {
        setInsuranceRates(
          insurancesList.map(i => ({
            insuranceId: i.id,
            name: i.name,
            dailyTariff: 0,
            dailyRate: 0
          }))
        );
      } else {
        // If editing, prepare the structure but don't overwrite
        const baseRates = insurancesList.map(i => ({
          insuranceId: i.id,
          name: i.name,
          dailyTariff: 0,
          dailyRate: 0
        }));
        
        setInsuranceRates(baseRates);
      }
      
      return insurancesList;
    }
  } catch (error) {
    console.error("Error loading insurances:", error);
    ErrorMessage("Error", "Failed to load insurance companies");
    return [];
  }
};


  const loadWards = async () => {
    const res = await axios.get(loadWardsdb);
    setWards(res.data.wards);
  };

  const loadBeds = async () => {
    const res = await axios.get(loadBedsdb);
    setBeds(res.data.beds);
  };

  const [formData, setFormData] = useState({
    name: '',
    type: '',
    capacity: '',
    dailyRate: '',
    bedNumber: '',
    wardId: '',
    status: 'Available'
  });

  const bedStatuses = ['Available', 'Occupied', 'Maintenance', 'Reserved'];

  useEffect(() => {
    loadWards();
    loadBeds();
  }, []);


useEffect(() => {
  if (openDialog && dialogType === "ward") {
    const initializeInsuranceRates = async () => {
      // Load all insurances
      const res = await axios.get(loadInsurancesddb);
      
      if (res.data.success) {
        const allInsurances = res.data.insurances;
        setInsurances(allInsurances);
        
        // Map insurance rates
        const mappedRates = allInsurances.map(insurance => {
          // If editing, find the matching rate from the ward
          if (editingItem && editingItem.insuranceRates) {
            const existingRate = editingItem.insuranceRates.find(
              rate => rate.insuranceId === insurance.id
            );
            
            if (existingRate) {
              return {
                insuranceId: insurance.id,
                name: insurance.name,
                dailyTariff: existingRate.dailyTariff,
                dailyRate: existingRate.dailyRate
              };
            }
          }
          
          // Default values for new ward or missing rates
          return {
            insuranceId: insurance.id,
            name: insurance.name,
            dailyTariff: 0,
            dailyRate: 0
          };
        });
        
        setInsuranceRates(mappedRates);
      }
    };
    
    initializeInsuranceRates();
  }
}, [openDialog, dialogType, editingItem]);


useEffect(() => {
  if (!applyAll) return;

  setInsuranceRates(prev =>
    prev.map(row => ({
      ...row,
      dailyRate: globalDailyRate,
      dailyTariff: globalDailyTariff
    }))
  );
}, [applyAll, globalDailyRate, globalDailyTariff]);


  // Ward filtering and pagination

  const filteredWards = useMemo(() => {
    return wards.filter((ward) => {
      const query = wardSearchQuery.toLowerCase();
      return (
        (ward.name || '').toLowerCase().includes(query) ||
        (ward.status || '').toLowerCase().includes(query) ||
        (ward.id?.toString() || '').includes(query)
      );
    });
  }, [wards, wardSearchQuery]);

  const paginatedWards = useMemo(() => {
    return filteredWards.slice(
      wardPage * wardRowsPerPage,
      wardPage * wardRowsPerPage + wardRowsPerPage
    );
  }, [filteredWards, wardPage, wardRowsPerPage]);

  // Bed filtering and pagination
  const filteredBeds = useMemo(() => {
    return beds.filter((bed) => {
      const query = bedSearchQuery.toLowerCase();
      return (
        (bed.bedNumber || '').toLowerCase().includes(query) 
      );
    });
  }, [beds, bedSearchQuery]);

  const paginatedBeds = useMemo(() => {
    return filteredBeds.slice(
      bedPage * bedRowsPerPage,
      bedPage * bedRowsPerPage + bedRowsPerPage
    );
  }, [filteredBeds, bedPage, bedRowsPerPage]);

 const handleOpenDialog = async (type, item = null) => {
  setDialogType(type);
  setEditingItem(item);
  
  if (item) {
    setFormData(item);
    
    // If editing a ward, load and pre-fill insurance rates
    if (type === 'ward') {
      // First, load all insurances
      await loadInsurances();
      
      // Then, if the ward has insurance rates, pre-fill them
      if (item.insuranceRates && item.insuranceRates.length > 0) {
        // Map the ward's insurance rates to the insurances
        setInsuranceRates(prevInsurances => {
          return prevInsurances.map(insurance => {
            // Find matching rate for this insurance
            const wardRate = item.insuranceRates.find(
              rate => rate.insuranceId === insurance.insuranceId
            );
            
            if (wardRate) {
              return {
                insuranceId: insurance.insuranceId,
                name: insurance.name,
                dailyTariff: wardRate.dailyTariff || 0,
                dailyRate: wardRate.dailyRate || 0
              };
            }
            
            // If no rate found, return default
            return {
              insuranceId: insurance.insuranceId,
              name: insurance.name,
              dailyTariff: 0,
              dailyRate: 0
            };
          });
        });
      }
    }
  } else {
    setFormData({
      name: '',
      type: '',
      capacity: '',
      dailyRate: '',
      bedNumber: '',
      wardId: '',
      status: 'Available'
    });
  }
  
  setOpenDialog(true);
};

  const handleCloseDialog = () => {
  setOpenDialog(false);
  setEditingItem(null);
  setApplyAll(false);
  setGlobalDailyRate("");
  setGlobalDailyTariff("");
  setInsuranceRates([]);
  setErrors({
    name: false,
    capacity: false,
    dailyRate: false
  });
};

const handleSaveWard = async () => {
  // 1️⃣ Basic ward validation
  const newErrors = {
    name: !formData.name.trim(),
    capacity: !formData.capacity || Number(formData.capacity) <= 0,
  };

  setErrors(newErrors);

  if (Object.values(newErrors).includes(true)) {
    ErrorMessage("Error", "Please correct the errors before saving.");
    return;
  }

  // 2️⃣ Insurance pricing validation
  const invalidInsurance = insuranceRates.some(
    (r) =>
      r.dailyRate === "" ||
      r.dailyTariff === "" ||
      isNaN(Number(r.dailyRate)) ||
      isNaN(Number(r.dailyTariff))
  );

  if (invalidInsurance) {
    ErrorMessage(
      "Error",
      "Daily Rate and Daily Tariff cannot be empty for any insurance."
    );
    return;
  }

  // 3️⃣ Confirm action
  const isEditing = editingItem && editingItem.id;
  const actionText = isEditing ? "Update" : "Create";
  
  const result = await Swal.fire({
    title: `${actionText} Ward?`,
    text: `Do you want to ${actionText.toLowerCase()} ward "${formData.name}" with ${formData.capacity} beds?`,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: `Yes, ${actionText}`,
    cancelButtonText: "Cancel",
  });

  if (!result.isConfirmed) return;

  // 4️⃣ Prepare data
  const wardData = {
    name: formData.name,
    capacity: Number(formData.capacity),
    status: "Active",
    insuranceRates: insuranceRates.map((r) => ({
      insuranceId: r.insuranceId,
      insuranceName: r.name,
      dailyRate: Number(r.dailyRate),
      dailyTariff: Number(r.dailyTariff),
    })),
  };

  // 5️⃣ Submit to backend
  try {
    let response;
    
    if (isEditing) {
      // UPDATE existing ward
      response = await axios.post(updateWarddb, {
        wardId: editingItem.id,
        ...wardData
      });
    } else {
      // CREATE new ward
      response = await axios.post(addWardWithBeds, wardData);
    }

    if (response.data.success) {
      successMessage(
        "Success", 
        isEditing 
          ? "Ward and insurance rates updated successfully" 
          : "Ward created with insurance pricing"
      );
      handleCloseDialog();
      loadWards();
      loadBeds();
    } else {
      ErrorMessage("Error", response.data.message);
    }
  } catch (error) {
    console.error(`Error ${isEditing ? 'updating' : 'creating'} ward:`, error);
    ErrorMessage("Error", `Failed to ${isEditing ? 'update' : 'create'} ward`);
  }
};


  const handleSaveBed = () => {
    const ward = wards.find(w => w.id === parseInt(formData.wardId));
    if (editingItem) {
      setBeds(beds.map(b => b.id === editingItem.id ? {
        ...b,
        ...formData,
        wardName: ward?.name,
        dailyRate: ward?.dailyRate
      } : b));
    } else {
      const newBed = {
        id: beds.length + 1,
        ...formData,
        wardName: ward?.name,
        patientName: '',
        admissionDate: '',
        dailyRate: ward?.dailyRate
      };
      setBeds([...beds, newBed]);
    }
    handleCloseDialog();
  };

 const handleDeleteWard = async (id) => {
  const ward = wards.find(w => w.id === id);
  
  if (!ward) {
    ErrorMessage("Error", "Ward not found");
    return;
  }

  // Check if ward has occupied beds
  if (ward.occupied > 0) {
    ErrorMessage(
      "Cannot Delete",
      `This ward has ${ward.occupied} occupied bed(s). Please discharge or transfer patients before deleting.`
    );
    return;
  }

  const result = await Swal.fire({
    title: "Delete Ward?",
    html: `
      <div style="text-align: left;">
        <p><strong>Ward:</strong> ${ward.name}</p>
        <p><strong>Capacity:</strong> ${ward.capacity} beds</p>
        <p><strong>Available Beds:</strong> ${ward.capacity - ward.occupied}</p>
        <p><strong>Insurance Rates:</strong> ${ward.insuranceRates?.length || 0} configured</p>
        <br/>
        <p style="color: #d32f2f; font-weight: 600;">
          ⚠️ This will permanently remove:
        </p>
        <ul style="color: #666;">
          <li>The ward</li>
          <li>All ${ward.capacity} beds</li>
          <li>All insurance pricing configurations</li>
        </ul>
      </div>
    `,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it",
    cancelButtonText: "Cancel"
  });

  if (!result.isConfirmed) return;

  try {
    const response = await axios.post(deleteWard, { wardId: id });

    if (response.data.success) {
      successMessage("Deleted", response.data.message || "Ward removed successfully");
      await loadWards();
      await loadBeds();
    } else {
      ErrorMessage("Error", response.data.message);
    }
  } catch (error) {
    console.error("Delete ward error:", error);
    ErrorMessage("Error", "Failed to delete ward");
  }
};

  
const handleDeleteBed = async (id) => {
  const bed = beds.find(b => b.id === id);
  
  if (!bed) {
    ErrorMessage("Error", "Bed not found");
    return;
  }

  // Check bed status
  if (bed.status === 'Occupied') {
    ErrorMessage(
      "Cannot Delete",
      "This bed is currently occupied. Please discharge the patient first."
    );
    return;
  }

  const result = await Swal.fire({
    title: "Delete Bed?",
    html: `
      <div style="text-align: left;">
        <p><strong>Bed Number:</strong> ${bed.bedNumber}</p>
        <p><strong>Ward:</strong> ${bed.wardName}</p>
        <p><strong>Status:</strong> ${bed.status}</p>
        <br/>
        <p style="color: #d32f2f; font-weight: 600;">
          ⚠️ This will:
        </p>
        <ul style="color: #666;">
          <li>Permanently remove this bed</li>
          <li>Reduce ward capacity by 1</li>
        </ul>
      </div>
    `,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it",
    cancelButtonText: "Cancel"
  });

  if (!result.isConfirmed) return;

  try {
    const res = await axios.post(deleteBed, { bedId: id });

    if (res.data.success) {
      successMessage("Deleted", res.data.message || "Bed removed and ward capacity updated");
      await loadBeds();
      await loadWards(); // ✅ Reload wards to show updated capacity
    } else {
      ErrorMessage("Error", res.data.message);
    }

  } catch (err) {
    console.error("Delete bed error:", err);
    ErrorMessage("Error", err.response?.data?.message || "Server error");
  }
};


  const getStatusColor = (status) => {
    switch (status) {
      case 'Available': return 'success';
      case 'Occupied': return 'error';
      case 'Maintenance': return 'warning';
      case 'Reserved': return 'info';
      default: return 'default';
    }
  };

  return (
    <Box sx={{ p: { xs: 1.5, sm: 2.5, md: 3.5 }, backgroundColor: pageBg, minHeight: '100%' }}>
      {/* Page header */}
      <Box sx={{ mb: 3 }}>
        <Typography sx={{
          fontSize: { xs: '1.5rem', sm: '1.875rem', md: '2.125rem' },
          fontWeight: 700,
          color: textPrimary,
          letterSpacing: '-0.02em',
          lineHeight: 1.2
        }}>
          Wards &amp; Beds Management
        </Typography>
        <Typography sx={{ color: textMuted, fontSize: { xs: '0.875rem', sm: '0.95rem' }, mt: 0.5 }}>
          Manage hospital wards, bed allocation, and pricing across the facility.
        </Typography>
      </Box>

      {/* Info banner — replaces the default MUI Alert which renders harshly
          in dark mode. This version reads as a subtle theme-aware notice. */}
      <Box sx={{
        mb: 3,
        p: 2,
        borderRadius: 2,
        backgroundColor: alpha(accents.primary, isDark ? 0.10 : 0.06),
        border: `1px solid ${alpha(accents.primary, isDark ? 0.25 : 0.15)}`,
        display: 'flex',
        alignItems: 'flex-start',
        gap: 1.5
      }}>
        <Box sx={{
          width: 36, height: 36, borderRadius: 1.5,
          backgroundColor: alpha(accents.primary, isDark ? 0.18 : 0.12),
          color: accents.primary,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          flexShrink: 0
        }}>
          <LocalHospital sx={{ fontSize: 20 }} />
        </Box>
        <Typography sx={{
          color: textPrimary,
          fontSize: { xs: '0.85rem', sm: '0.92rem' },
          lineHeight: 1.55,
          pt: 0.5
        }}>
          Changes here sync automatically with{' '}
          <Box component="span" sx={{ fontWeight: 600, color: accents.primary }}>Admissions</Box>,{' '}
          <Box component="span" sx={{ fontWeight: 600, color: accents.primary }}>Billing</Box>, and the{' '}
          <Box component="span" sx={{ fontWeight: 600, color: accents.primary }}>Ward Dashboard</Box>.
        </Typography>
      </Box>

      <Box sx={{
        borderBottom: `1px solid ${borderSubtle}`,
        mb: 3
      }}>
        <Tabs
          value={activeTab}
          onChange={(e, v) => setActiveTab(v)}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            '& .MuiTab-root': {
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '0.95rem',
              color: textMuted,
              minHeight: 48,
              '&.Mui-selected': { color: accents.primary }
            },
            '& .MuiTabs-indicator': {
              backgroundColor: accents.primary,
              height: 3,
              borderRadius: '3px 3px 0 0'
            }
          }}
        >
          <Tab label="Wards" icon={<LocalHospital />} iconPosition="start" sx={{ minWidth: { xs: 100, sm: 120 } }} />
          <Tab label="Beds" icon={<Bed />} iconPosition="start" sx={{ minWidth: { xs: 100, sm: 120 } }} />
        </Tabs>
      </Box>

      {/* Wards Tab */}
      {activeTab === 0 && (
        <Box>
          <Box sx={{
            mb: 3,
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'stretch', sm: 'center' },
            gap: { xs: 1.5, sm: 2 }
          }}>
            <Box>
              <Typography sx={{
                fontSize: { xs: '1.15rem', sm: '1.35rem' },
                fontWeight: 700,
                color: textPrimary,
                letterSpacing: '-0.01em'
              }}>
                Ward Management
              </Typography>
              <Typography sx={{ fontSize: '0.85rem', color: textMuted, mt: 0.25 }}>
                Configure wards, capacity and insurance rates.
              </Typography>
            </Box>
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() => handleOpenDialog('ward')}
              fullWidth={isMobile}
              size={isMobile ? 'medium' : 'large'}
              sx={{
                textTransform: 'none',
                fontWeight: 600,
                borderRadius: 1.5,
                px: 2.5,
                background: `linear-gradient(135deg, ${accents.primary} 0%, ${alpha(accents.primary, 0.85)} 100%)`,
                boxShadow: `0 6px 16px ${alpha(accents.primary, 0.35)}`,
                '&:hover': {
                  background: `linear-gradient(135deg, ${alpha(accents.primary, 0.95)} 0%, ${alpha(accents.primary, 0.75)} 100%)`,
                  boxShadow: `0 8px 22px ${alpha(accents.primary, 0.45)}`
                }
              }}
            >
              Add Ward
            </Button>
          </Box>

          {/* Stat tiles — each gets a translucent semantic-colored icon
              chip that reads beautifully on both light and black themes. */}
          {(() => {
            const totalCapacity = wards.reduce((acc, w) => acc + w.capacity, 0);
            const totalOccupied = wards.reduce((acc, w) => acc + w.occupied, 0);
            const occupancyRate = totalCapacity > 0 ? ((totalOccupied / totalCapacity) * 100).toFixed(1) : '0.0';
            const tiles = [
              { label: 'Total Wards', value: wards.length, color: accents.primary, Icon: LocalHospital },
              { label: 'Total Capacity', value: totalCapacity, color: accents.success, Icon: Bed },
              { label: 'Occupied', value: totalOccupied, color: accents.danger, Icon: CheckCircle },
              { label: 'Occupancy Rate', value: `${occupancyRate}%`, color: accents.warning, Icon: MonetizationOn }
            ];
            return (
              <Grid container spacing={{ xs: 1.5, sm: 2.5 }} sx={{ mb: { xs: 2.5, sm: 3 } }}>
                {tiles.map(({ label, value, color, Icon }) => (
                  <Grid item xs={6} sm={6} md={3} key={label}>
                    <Box sx={{
                      height: '100%',
                      p: { xs: 1.75, sm: 2.25 },
                      borderRadius: 2,
                      backgroundColor: surfaceBg,
                      backgroundImage: 'none',
                      border: `1px solid ${borderSubtle}`,
                      boxShadow: cardShadow,
                      display: 'flex',
                      alignItems: 'center',
                      gap: { xs: 1.25, sm: 1.75 },
                      position: 'relative',
                      overflow: 'hidden',
                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0, left: 0, bottom: 0,
                        width: 3,
                        backgroundColor: color
                      }
                    }}>
                      <Box sx={{
                        width: { xs: 40, sm: 48 },
                        height: { xs: 40, sm: 48 },
                        borderRadius: 1.5,
                        backgroundColor: alpha(color, isDark ? 0.18 : 0.12),
                        color: color,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0
                      }}>
                        <Icon sx={{ fontSize: { xs: 22, sm: 26 } }} />
                      </Box>
                      <Box sx={{ minWidth: 0 }}>
                        <Typography sx={{
                          fontSize: { xs: '1.35rem', sm: '1.625rem', md: '1.875rem' },
                          fontWeight: 700,
                          color: textPrimary,
                          letterSpacing: '-0.02em',
                          lineHeight: 1.1
                        }}>
                          {value}
                        </Typography>
                        <Typography sx={{
                          fontSize: { xs: '0.72rem', sm: '0.82rem' },
                          color: textMuted,
                          fontWeight: 500,
                          mt: 0.25
                        }}>
                          {label}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            );
          })()}

          <Paper sx={{
            boxShadow: cardShadow,
            backgroundColor: surfaceBg,
            backgroundImage: 'none',
            border: `1px solid ${borderSubtle}`,
            borderRadius: 2,
            overflow: 'hidden'
          }}>
            <Box sx={{ p: { xs: 1.5, sm: 2 }, borderBottom: `1px solid ${borderSubtle}` }}>
              <TextField
                fullWidth
                placeholder="Search wards by name, status, or id…"
                value={wardSearchQuery}
                onChange={(e) => {
                  setWardSearchQuery(e.target.value);
                  setWardPage(0);
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search sx={{ color: textMuted, fontSize: { xs: 18, sm: 20 } }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: fieldBg,
                    borderRadius: 1.5
                  },
                  '& .MuiInputBase-input': {
                    fontSize: { xs: '0.875rem', sm: '0.95rem' }
                  }
                }}
              />
            </Box>

            <TableContainer sx={{ overflowX: 'auto' }}>
              <Table sx={{ minWidth: { xs: 500, sm: 650, md: 750 } }}>
                <TableHead>
                  <TableRow sx={{ backgroundColor: surfaceBg2 }}>
                    <TableCell sx={{ fontWeight: 700, color: textPrimary, minWidth: { xs: 120, sm: 150 }, fontSize: { xs: '0.78rem', sm: '0.82rem' }, textTransform: 'uppercase', letterSpacing: '0.04em', borderColor: borderSubtle }}>
                      Ward
                    </TableCell>
                    <TableCell align="center" sx={{ fontWeight: 700, color: textPrimary, minWidth: 80, display: { xs: 'none', sm: 'table-cell' }, fontSize: { xs: '0.78rem', sm: '0.82rem' }, textTransform: 'uppercase', letterSpacing: '0.04em', borderColor: borderSubtle }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                        <People sx={{ fontSize: 16, color: accents.primary }} />
                        Cap.
                      </Box>
                    </TableCell>
                    <TableCell align="center" sx={{ fontWeight: 700, color: textPrimary, minWidth: 80, display: { xs: 'none', sm: 'table-cell' }, fontSize: { xs: '0.78rem', sm: '0.82rem' }, textTransform: 'uppercase', letterSpacing: '0.04em', borderColor: borderSubtle }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                        <PersonOutline sx={{ fontSize: 16, color: accents.danger }} />
                        Occ.
                      </Box>
                    </TableCell>
                    <TableCell align="center" sx={{ fontWeight: 700, color: textPrimary, minWidth: 80, fontSize: { xs: '0.78rem', sm: '0.82rem' }, textTransform: 'uppercase', letterSpacing: '0.04em', borderColor: borderSubtle }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                        <CheckCircle sx={{ fontSize: 16, color: accents.success }} />
                        <Box component="span" sx={{ display: { xs: 'none', md: 'inline' } }}>Avail.</Box>
                      </Box>
                    </TableCell>
                    <TableCell align="center" sx={{ fontWeight: 700, color: textPrimary, minWidth: 80, fontSize: { xs: '0.78rem', sm: '0.82rem' }, textTransform: 'uppercase', letterSpacing: '0.04em', borderColor: borderSubtle }}>
                      Status
                    </TableCell>
                    <TableCell align="center" sx={{ fontWeight: 700, color: textPrimary, minWidth: { xs: 80, sm: 100 }, fontSize: { xs: '0.78rem', sm: '0.82rem' }, textTransform: 'uppercase', letterSpacing: '0.04em', borderColor: borderSubtle }}>
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedWards.length > 0 ? (
                    paginatedWards.map((ward) => (
                      <TableRow key={ward.id} sx={{
                        '&:hover': { backgroundColor: rowHoverBg },
                        '& .MuiTableCell-root': { borderColor: borderSubtle, color: textPrimary }
                      }}>
                        <TableCell>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 0.75, sm: 1.25 } }}>
                            <Box sx={{
                              width: 32, height: 32, borderRadius: 1.5,
                              backgroundColor: alpha(accents.primary, isDark ? 0.18 : 0.12),
                              color: accents.primary,
                              display: 'flex', alignItems: 'center', justifyContent: 'center',
                              flexShrink: 0
                            }}>
                              <Hotel sx={{ fontSize: { xs: 16, sm: 18 } }} />
                            </Box>
                            <Box>
                              <Typography sx={{ fontWeight: 600, color: textPrimary, fontSize: { xs: '0.875rem', sm: '0.95rem' }, lineHeight: 1.25 }}>
                                {ward.name}
                              </Typography>
                              <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                                <Typography sx={{ color: textMuted, fontSize: '0.72rem' }}>
                                  {ward.capacity} beds • {ward.occupied} occ.
                                </Typography>
                              </Box>
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell align="center" sx={{ display: { xs: 'none', sm: 'table-cell' } }}>
                          <Box sx={{
                            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                            width: { xs: 28, sm: 34 }, height: { xs: 28, sm: 34 },
                            borderRadius: '50%',
                            backgroundColor: alpha(accents.primary, isDark ? 0.18 : 0.12),
                            color: accents.primary,
                            fontWeight: 700,
                            fontSize: { xs: 12, sm: 13 }
                          }}>
                            {ward.capacity}
                          </Box>
                        </TableCell>
                        <TableCell align="center" sx={{ display: { xs: 'none', sm: 'table-cell' } }}>
                          <Box sx={{
                            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                            width: { xs: 28, sm: 34 }, height: { xs: 28, sm: 34 },
                            borderRadius: '50%',
                            backgroundColor: alpha(accents.danger, isDark ? 0.18 : 0.12),
                            color: accents.danger,
                            fontWeight: 700,
                            fontSize: { xs: 12, sm: 13 }
                          }}>
                            {ward.occupied}
                          </Box>
                        </TableCell>
                        <TableCell align="center">
                          <Box sx={{
                            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                            width: { xs: 28, sm: 34 }, height: { xs: 28, sm: 34 },
                            borderRadius: '50%',
                            backgroundColor: alpha(accents.success, isDark ? 0.18 : 0.12),
                            color: accents.success,
                            fontWeight: 700,
                            fontSize: { xs: 12, sm: 13 }
                          }}>
                            {ward.capacity - ward.occupied}
                          </Box>
                        </TableCell>
                        <TableCell align="center">
                          <Chip
                            label={ward.status}
                            size="small"
                            sx={{
                              fontSize: { xs: '0.68rem', sm: '0.75rem' },
                              fontWeight: 700,
                              height: { xs: 22, sm: 24 },
                              backgroundColor: alpha(accents.success, isDark ? 0.18 : 0.14),
                              color: accents.success,
                              border: `1px solid ${alpha(accents.success, 0.3)}`
                            }}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Stack direction="row" spacing={0.5} justifyContent="center">
                            <Tooltip title="Edit ward">
                              <IconButton
                                size="small"
                                onClick={() => handleOpenDialog('ward', ward)}
                                sx={{
                                  p: { xs: 0.5, sm: 0.75 },
                                  color: accents.primary,
                                  '&:hover': { backgroundColor: alpha(accents.primary, 0.12) }
                                }}
                              >
                                <Edit sx={{ fontSize: { xs: 16, sm: 18 } }} />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Delete ward">
                              <IconButton
                                size="small"
                                onClick={() => handleDeleteWard(ward.id)}
                                sx={{
                                  p: { xs: 0.5, sm: 0.75 },
                                  color: accents.danger,
                                  '&:hover': { backgroundColor: alpha(accents.danger, 0.12) }
                                }}
                              >
                                <Delete sx={{ fontSize: { xs: 16, sm: 18 } }} />
                              </IconButton>
                            </Tooltip>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6} align="center" sx={{ py: { xs: 5, sm: 8 }, borderColor: borderSubtle }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                          <Box sx={{
                            width: 48, height: 48, borderRadius: 2,
                            backgroundColor: alpha(accents.primary, 0.12),
                            color: accents.primary,
                            display: 'flex', alignItems: 'center', justifyContent: 'center'
                          }}>
                            <LocalHospital sx={{ fontSize: 26 }} />
                          </Box>
                          <Typography sx={{ color: textMuted, fontSize: { xs: '0.85rem', sm: '0.95rem' } }}>
                            No wards found
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={filteredWards.length}
              rowsPerPage={wardRowsPerPage}
              page={wardPage}
              onPageChange={(e, newPage) => setWardPage(newPage)}
              onRowsPerPageChange={(e) => {
                setWardRowsPerPage(parseInt(e.target.value, 10));
                setWardPage(0);
              }}
              sx={{
                borderTop: `1px solid ${borderSubtle}`,
                color: textMuted,
                '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
                  fontSize: { xs: '0.75rem', sm: '0.875rem' }
                },
                '.MuiTablePagination-select': {
                  fontSize: { xs: '0.75rem', sm: '0.875rem' }
                }
              }}
            />
          </Paper>
        </Box>
      )}

      {/* Beds Tab */}
      {activeTab === 1 && (
        <Box>
          <Box sx={{
            mb: 3,
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'stretch', sm: 'center' },
            gap: 2
          }}>
            <Box>
              <Typography sx={{
                fontSize: { xs: '1.15rem', sm: '1.35rem' },
                fontWeight: 700,
                color: textPrimary,
                letterSpacing: '-0.01em'
              }}>
                Bed Management
              </Typography>
              <Typography sx={{ fontSize: '0.85rem', color: textMuted, mt: 0.25 }}>
                Track bed status, assignments and admissions in real time.
              </Typography>
            </Box>
          </Box>

          <Paper sx={{
            boxShadow: cardShadow,
            backgroundColor: surfaceBg,
            backgroundImage: 'none',
            border: `1px solid ${borderSubtle}`,
            borderRadius: 2,
            overflow: 'hidden'
          }}>
            <Box sx={{ p: 2, borderBottom: `1px solid ${borderSubtle}` }}>
              <TextField
                fullWidth
                placeholder="Search beds by number or id…"
                value={bedSearchQuery}
                onChange={(e) => {
                  setBedSearchQuery(e.target.value);
                  setBedPage(0);
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search sx={{ color: textMuted, fontSize: 20 }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: fieldBg,
                    borderRadius: 1.5
                  }
                }}
              />
            </Box>

            <TableContainer sx={{ overflowX: 'auto' }}>
              <Table sx={{ minWidth: { xs: 650, md: 750 } }}>
                <TableHead>
                  <TableRow sx={{ backgroundColor: surfaceBg2 }}>
                    {['Bed Number', 'Ward', 'Status', 'Patient Name', 'Admission Date', 'Actions'].map((label, i) => {
                      const align = i === 2 || i === 5 ? 'center' : 'left';
                      const responsive = label === 'Patient Name'
                        ? { display: { xs: 'none', md: 'table-cell' } }
                        : label === 'Admission Date'
                          ? { display: { xs: 'none', lg: 'table-cell' } }
                          : {};
                      return (
                        <TableCell
                          key={label}
                          align={align}
                          sx={{
                            fontWeight: 700,
                            color: textPrimary,
                            fontSize: '0.78rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.04em',
                            borderColor: borderSubtle,
                            minWidth: i === 0 ? 120 : i === 1 ? 120 : i === 2 ? 100 : i === 3 ? 150 : i === 4 ? 120 : 120,
                            ...responsive
                          }}
                        >
                          {label}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedBeds.length > 0 ? (
                    paginatedBeds.map((bed) => (
                      <TableRow key={bed.id} sx={{
                        '&:hover': { backgroundColor: rowHoverBg },
                        '& .MuiTableCell-root': { borderColor: borderSubtle, color: textPrimary }
                      }}>
                        <TableCell>
                          <Stack direction="row" spacing={1.25} alignItems="center">
                            <Box sx={{
                              width: 32, height: 32, borderRadius: 1.5,
                              backgroundColor: alpha(accents.success, isDark ? 0.18 : 0.12),
                              color: accents.success,
                              display: 'flex', alignItems: 'center', justifyContent: 'center'
                            }}>
                              <Bed sx={{ fontSize: 18 }} />
                            </Box>
                            <Box>
                              <Typography sx={{ fontWeight: 600, fontSize: '0.92rem', color: textPrimary, lineHeight: 1.2 }}>
                                {bed.bedNumber}
                              </Typography>
                              <Box sx={{ display: { xs: 'block', md: 'none' } }}>
                                {bed.patientName && (
                                  <Typography sx={{ fontSize: '0.72rem', color: textMuted }}>
                                    {bed.patientName}
                                  </Typography>
                                )}
                              </Box>
                            </Box>
                          </Stack>
                        </TableCell>
                        <TableCell>
                          <Typography sx={{ fontSize: '0.9rem', color: textPrimary }}>{bed.wardName}</Typography>
                          <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                            <Typography sx={{ fontSize: '0.72rem', color: textMuted }}>
                              {bed.dailyRate}
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell align="center">
                          {(() => {
                            const c = bed.status === 'Available' ? accents.success
                                    : bed.status === 'Occupied'  ? accents.danger
                                    : bed.status === 'Maintenance' ? accents.warning
                                    : accents.primary;
                            return (
                              <Chip
                                label={bed.status}
                                size="small"
                                sx={{
                                  fontWeight: 700,
                                  fontSize: '0.72rem',
                                  height: 22,
                                  backgroundColor: alpha(c, isDark ? 0.18 : 0.14),
                                  color: c,
                                  border: `1px solid ${alpha(c, 0.3)}`
                                }}
                              />
                            );
                          })()}
                        </TableCell>
                        <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>
                          <Typography sx={{ fontSize: '0.9rem', color: bed.patientName ? textPrimary : textMuted }}>
                            {bed.patientName || '—'}
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ display: { xs: 'none', lg: 'table-cell' } }}>
                          <Typography sx={{ fontSize: '0.9rem', color: bed.admissionDate ? textPrimary : textMuted }}>
                            {bed.admissionDate || '—'}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Stack direction="row" spacing={0.5} justifyContent="center">
                            {bed.status === 'Available' && (
                              <Tooltip title="Assign Patient">
                                <IconButton size="small" sx={{
                                  color: accents.primary,
                                  '&:hover': { backgroundColor: alpha(accents.primary, 0.12) }
                                }}>
                                  <PersonAdd fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            )}
                            <Tooltip title="Delete bed">
                              <IconButton
                                size="small"
                                onClick={() => handleDeleteBed(bed.id)}
                                sx={{
                                  color: accents.danger,
                                  '&:hover': { backgroundColor: alpha(accents.danger, 0.12) }
                                }}
                              >
                                <Delete fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={7} align="center" sx={{ py: 8, borderColor: borderSubtle }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                          <Box sx={{
                            width: 48, height: 48, borderRadius: 2,
                            backgroundColor: alpha(accents.success, 0.12),
                            color: accents.success,
                            display: 'flex', alignItems: 'center', justifyContent: 'center'
                          }}>
                            <Bed sx={{ fontSize: 26 }} />
                          </Box>
                          <Typography sx={{ color: textMuted }}>
                            No beds found matching your search criteria
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50]}
              component="div"
              count={filteredBeds.length}
              rowsPerPage={bedRowsPerPage}
              page={bedPage}
              onPageChange={(e, newPage) => setBedPage(newPage)}
              onRowsPerPageChange={(e) => {
                setBedRowsPerPage(parseInt(e.target.value, 10));
                setBedPage(0);
              }}
              sx={{
                borderTop: `1px solid ${borderSubtle}`,
                color: textMuted,
                '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
                  fontSize: { xs: '0.75rem', sm: '0.875rem' }
                }
              }}
            />
          </Paper>
        </Box>
      )}

      {/* Dialog */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth
        fullScreen={isMobile}
        PaperProps={{
          sx: {
            borderRadius: { xs: 0, sm: 3 },
            backgroundColor: pageBg,
            backgroundImage: 'none',
            border: isDark ? `1px solid ${borderSubtle}` : 'none',
            boxShadow: isDark
              ? '0 24px 64px rgba(0,0,0,0.7)'
              : '0 24px 64px rgba(15,23,42,0.18)',
            overflow: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{
          background: dialogType === 'ward'
            ? `linear-gradient(135deg, ${accents.primary} 0%, ${alpha(accents.primary, 0.78)} 100%)`
            : `linear-gradient(135deg, ${accents.success} 0%, ${alpha(accents.success, 0.78)} 100%)`,
          color: 'white',
          py: 2.5,
          px: { xs: 2.5, sm: 4 },
          position: 'relative',
          '&::after': {
            content: '""',
            position: 'absolute',
            inset: 0,
            background: 'radial-gradient(circle at top right, rgba(255,255,255,0.12), transparent 60%)',
            pointerEvents: 'none'
          }
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'relative', zIndex: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.75 }}>
              <Box sx={{
                width: 48, height: 48, borderRadius: 1.75,
                backgroundColor: 'rgba(255,255,255,0.18)',
                border: '1px solid rgba(255,255,255,0.25)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                backdropFilter: 'blur(8px)'
              }}>
                {dialogType === 'ward' ? <LocalHospital sx={{ fontSize: 26 }} /> : <Bed sx={{ fontSize: 26 }} />}
              </Box>
              <Box>
                <Typography sx={{ fontSize: { xs: '1.05rem', sm: '1.2rem' }, fontWeight: 700, letterSpacing: '-0.01em' }}>
                  {dialogType === 'ward'
                    ? (editingItem ? `Edit Ward — ${editingItem.name}` : 'Add New Ward')
                    : (editingItem ? 'Edit Bed' : 'Add New Bed')}
                </Typography>
                <Typography sx={{ fontSize: '0.82rem', opacity: 0.9 }}>
                  {dialogType === 'ward'
                    ? 'Configure capacity and per-insurance pricing.'
                    : 'Assign a bed to a ward and set its status.'}
                </Typography>
              </Box>
            </Box>
            <IconButton
              onClick={handleCloseDialog}
              sx={{
                color: 'white',
                backgroundColor: 'rgba(255,255,255,0.12)',
                border: '1px solid rgba(255,255,255,0.18)',
                '&:hover': { backgroundColor: 'rgba(255,255,255,0.22)' }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ p: { xs: 2, sm: 3 }, backgroundColor: pageBg }}>
          <Box sx={{ pt: 1.5 }}>
            {dialogType === 'ward' ? (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                {/* Ward details */}
                <Paper elevation={0} sx={{
                  p: { xs: 2, sm: 2.5 },
                  borderRadius: 2,
                  backgroundColor: surfaceBg,
                  backgroundImage: 'none',
                  border: `1px solid ${borderSubtle}`,
                  boxShadow: cardShadow
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 2, pb: 1.5, borderBottom: `1px solid ${borderSubtle}` }}>
                    <Box sx={{ width: 4, height: 22, borderRadius: 2, backgroundColor: accents.primary, boxShadow: `0 0 12px ${alpha(accents.primary, 0.5)}` }} />
                    <Typography sx={{ fontWeight: 700, color: textPrimary, letterSpacing: '-0.01em' }}>
                      Ward Details
                    </Typography>
                  </Box>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Ward Name"
                        value={formData.name}
                        error={errors.name}
                        helperText={errors.name ? 'Ward name is required' : ''}
                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                        sx={{ '& .MuiOutlinedInput-root': { backgroundColor: fieldBg, borderRadius: 1.5 } }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        type="number"
                        label="Capacity"
                        value={formData.capacity}
                        error={errors.capacity}
                        helperText={errors.capacity ? 'Capacity must be positive' : ''}
                        onChange={(e) => setFormData({ ...formData, capacity: e.target.value })}
                        sx={{ '& .MuiOutlinedInput-root': { backgroundColor: fieldBg, borderRadius: 1.5 } }}
                      />
                    </Grid>
                  </Grid>
                </Paper>

                {/* Bulk pricing */}
                <Paper elevation={0} sx={{
                  p: { xs: 2, sm: 2.5 },
                  borderRadius: 2,
                  backgroundColor: surfaceBg,
                  backgroundImage: 'none',
                  border: `1px solid ${borderSubtle}`,
                  boxShadow: cardShadow
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 2, pb: 1.5, borderBottom: `1px solid ${borderSubtle}` }}>
                    <Box sx={{ width: 4, height: 22, borderRadius: 2, backgroundColor: accents.warning, boxShadow: `0 0 12px ${alpha(accents.warning, 0.5)}` }} />
                    <Box sx={{ flex: 1 }}>
                      <Typography sx={{ fontWeight: 700, color: textPrimary, letterSpacing: '-0.01em', lineHeight: 1.2 }}>
                        Bulk Pricing
                      </Typography>
                      <Typography sx={{ fontSize: '0.78rem', color: textMuted, mt: 0.25 }}>
                        Apply the same rate &amp; tariff to every insurance provider at once.
                      </Typography>
                    </Box>
                  </Box>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        type="number"
                        label="Daily Rate (GH₵)"
                        value={globalDailyRate}
                        onChange={(e) => setGlobalDailyRate(e.target.value)}
                        sx={{ '& .MuiOutlinedInput-root': { backgroundColor: fieldBg, borderRadius: 1.5 } }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        type="number"
                        label="Daily Tariff (GH₵)"
                        value={globalDailyTariff}
                        onChange={(e) => setGlobalDailyTariff(e.target.value)}
                        sx={{ '& .MuiOutlinedInput-root': { backgroundColor: fieldBg, borderRadius: 1.5 } }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControlLabel
                        sx={{
                          m: 0,
                          p: 1.25,
                          borderRadius: 1.5,
                          width: '100%',
                          backgroundColor: alpha(accents.warning, isDark ? 0.10 : 0.06),
                          border: `1px solid ${alpha(accents.warning, isDark ? 0.25 : 0.18)}`
                        }}
                        control={
                          <Checkbox
                            checked={applyAll}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setApplyAll(checked);
                              if (!checked) {
                                setGlobalDailyRate('');
                                setGlobalDailyTariff('');
                              }
                            }}
                            sx={{
                              color: accents.warning,
                              '&.Mui-checked': { color: accents.warning }
                            }}
                          />
                        }
                        label={
                          <Typography sx={{ color: textPrimary, fontSize: '0.9rem' }}>
                            Apply Daily Rate &amp; Tariff to all insurance companies
                          </Typography>
                        }
                      />
                    </Grid>
                  </Grid>
                </Paper>

                {/* Per-insurance pricing table */}
                <Paper elevation={0} sx={{
                  borderRadius: 2,
                  backgroundColor: surfaceBg,
                  backgroundImage: 'none',
                  border: `1px solid ${borderSubtle}`,
                  boxShadow: cardShadow,
                  overflow: 'hidden'
                }}>
                  <Box sx={{ p: { xs: 2, sm: 2.5 }, pb: 1.5, display: 'flex', alignItems: 'center', gap: 1.25, borderBottom: `1px solid ${borderSubtle}` }}>
                    <Box sx={{ width: 4, height: 22, borderRadius: 2, backgroundColor: accents.success, boxShadow: `0 0 12px ${alpha(accents.success, 0.5)}` }} />
                    <Box sx={{ flex: 1 }}>
                      <Typography sx={{ fontWeight: 700, color: textPrimary, letterSpacing: '-0.01em', lineHeight: 1.2 }}>
                        Per-Insurance Pricing
                      </Typography>
                      <Typography sx={{ fontSize: '0.78rem', color: textMuted, mt: 0.25 }}>
                        Override rates individually for each insurance provider.
                      </Typography>
                    </Box>
                  </Box>
                  <TableContainer>
                    <Table size="small">
                      <TableHead>
                        <TableRow sx={{ backgroundColor: surfaceBg2 }}>
                          <TableCell sx={{ fontWeight: 700, color: textPrimary, fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '0.04em', borderColor: borderSubtle }}>
                            Insurance
                          </TableCell>
                          <TableCell sx={{ fontWeight: 700, color: textPrimary, fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '0.04em', borderColor: borderSubtle }}>
                            Daily Tariff (GH₵)
                          </TableCell>
                          <TableCell sx={{ fontWeight: 700, color: textPrimary, fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '0.04em', borderColor: borderSubtle }}>
                            Daily Rate (GH₵)
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {insuranceRates.map((row, index) => (
                          <TableRow key={row.insuranceId} sx={{
                            '& .MuiTableCell-root': { borderColor: borderSubtle, color: textPrimary }
                          }}>
                            <TableCell sx={{ fontWeight: 600 }}>{row.name}</TableCell>
                            <TableCell>
                              <TextField
                                size="small"
                                type="number"
                                fullWidth
                                value={row.dailyTariff}
                                onChange={(e) => {
                                  const updated = [...insuranceRates];
                                  updated[index].dailyTariff = e.target.value;
                                  setInsuranceRates(updated);
                                }}
                                inputProps={{ min: 0, step: 0.01 }}
                                sx={{ '& .MuiOutlinedInput-root': { backgroundColor: fieldBg, borderRadius: 1 } }}
                              />
                            </TableCell>
                            <TableCell>
                              <TextField
                                size="small"
                                type="number"
                                fullWidth
                                value={row.dailyRate}
                                onChange={(e) => {
                                  const updated = [...insuranceRates];
                                  updated[index].dailyRate = e.target.value;
                                  setInsuranceRates(updated);
                                }}
                                inputProps={{ min: 0, step: 0.01 }}
                                sx={{ '& .MuiOutlinedInput-root': { backgroundColor: fieldBg, borderRadius: 1 } }}
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
              </Box>
            ) : (
              <Paper elevation={0} sx={{
                p: { xs: 2, sm: 2.5 },
                borderRadius: 2,
                backgroundColor: surfaceBg,
                backgroundImage: 'none',
                border: `1px solid ${borderSubtle}`,
                boxShadow: cardShadow
              }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 2, pb: 1.5, borderBottom: `1px solid ${borderSubtle}` }}>
                  <Box sx={{ width: 4, height: 22, borderRadius: 2, backgroundColor: accents.success, boxShadow: `0 0 12px ${alpha(accents.success, 0.5)}` }} />
                  <Typography sx={{ fontWeight: 700, color: textPrimary, letterSpacing: '-0.01em' }}>
                    Bed Details
                  </Typography>
                </Box>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Bed Number"
                      value={formData.bedNumber}
                      onChange={(e) => setFormData({ ...formData, bedNumber: e.target.value })}
                      sx={{ '& .MuiOutlinedInput-root': { backgroundColor: fieldBg, borderRadius: 1.5 } }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <InputLabel>Ward</InputLabel>
                      <Select
                        value={formData.wardId}
                        label="Ward"
                        onChange={(e) => setFormData({ ...formData, wardId: e.target.value })}
                        sx={{ backgroundColor: fieldBg, borderRadius: 1.5 }}
                      >
                        {wards.map((ward) => (
                          <MenuItem key={ward.id} value={ward.id}>
                            {ward.name}{ward.type ? ` — ${ward.type}` : ''}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <InputLabel>Status</InputLabel>
                      <Select
                        value={formData.status}
                        label="Status"
                        onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                        sx={{ backgroundColor: fieldBg, borderRadius: 1.5 }}
                      >
                        {bedStatuses.map((status) => (
                          <MenuItem key={status} value={status}>{status}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Paper>
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{
          px: { xs: 2, sm: 3 },
          py: 2,
          backgroundColor: surfaceBg,
          borderTop: `1px solid ${borderSubtle}`,
          gap: 1.5
        }}>
          <Button
            onClick={handleCloseDialog}
            variant="outlined"
            sx={{
              borderRadius: 1.5,
              textTransform: 'none',
              px: 3,
              fontWeight: 600,
              borderColor: borderStrong,
              color: textPrimary,
              '&:hover': {
                borderColor: borderStrong,
                backgroundColor: rowHoverBg
              }
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={dialogType === 'ward' ? handleSaveWard : handleSaveBed}
            sx={{
              borderRadius: 1.5,
              textTransform: 'none',
              px: 4,
              fontWeight: 600,
              background: dialogType === 'ward'
                ? `linear-gradient(135deg, ${accents.primary} 0%, ${alpha(accents.primary, 0.82)} 100%)`
                : `linear-gradient(135deg, ${accents.success} 0%, ${alpha(accents.success, 0.82)} 100%)`,
              boxShadow: `0 6px 16px ${alpha(dialogType === 'ward' ? accents.primary : accents.success, 0.35)}`,
              '&:hover': {
                boxShadow: `0 8px 22px ${alpha(dialogType === 'ward' ? accents.primary : accents.success, 0.45)}`
              }
            }}
          >
            {editingItem ? 'Save Changes' : 'Create'}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}